export const NodeEnv = {
  dev: 'development',
  prod: 'production'
} as const;
export type NodeEnvId = keyof typeof NodeEnv;

export const isNodeEnv = (id: NodeEnvId) =>
  process.env.REACT_APP_DEPLOY_ENV === NodeEnv[id];

const RUN_LOCAL = process.env.REACT_APP_RUN_LOCAL === 'true';
const LOCAL_API_URL = `http://localhost:3000/v1/backoffice`;
const REMOTE_API_URL = `https://api.blazepod.${isNodeEnv('prod') ? 'live' : 'dev'}/v1/backoffice`;
export const getApiRoot = () => (RUN_LOCAL ? LOCAL_API_URL : REMOTE_API_URL);
